import { Injectable, inject } from '@angular/core';
import { TranslationsLibService } from '@nutricontrol/app360-shared';
@Injectable({
  providedIn: 'root',
})
export class LegalAgreementsLibService {
  translationsLib = inject(TranslationsLibService);

  async showLegalAdvice() {
    this.openExternalUrl(
      this.translationsLib.get('configuration_legal_advice_url')
    );
  }
  async showPrivacyPolicy() {
    this.openExternalUrl(
      this.translationsLib.get('configuration_privacy_policy_url')
    );
  }
  async showCookiePolicy() {
    this.openExternalUrl(
      this.translationsLib.get('configuration_cookie_policy_url')
    );
  }

  private openExternalUrl(url: string) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
